import {UntypedFormControl, FormGroupDirective} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';

export class OnSubmitErrorStateMatcher implements ErrorStateMatcher {
  constructor() {}

  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective): boolean {
    return !!(control && control.invalid && form.submitted);
  }
}
